"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface OtherFinancialLiabilitiesTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  {
    id: "oth_fin_liab_q1",
    question: "Are there any accounting estimates related to other financial liabilities?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "oth_fin_liab_q2",
    question: "Does the entity have material payables to capex vendors as at period-end?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "oth_fin_liab_q2_followup_confirmations",
      question: "Are we planning on sending confirmations for testing the balance?",
      type: "radio",
      options: ["Yes", "No"],
    },
  },
  {
    id: "oth_fin_liab_q3",
    question:
      "Does the entity have material current and non-current classification of other financial liabilities in financial statements?",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function OtherFinancialLiabilitiesTailoringQuestions({
  onBack,
}: OtherFinancialLiabilitiesTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Other Financial Liabilities"
      title="Other Financial Liabilities - Tailoring Questions"
      description="Customize the audit program for Other Financial Liabilities"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}
